module.exports = require("prismjs/components/prism-sql.js");